export default [
    { boarder: [0, 0, 0, 1], fill: [254, 240, 217, 1] },
    { boarder: [0, 0, 0, 1], fill: [253, 204, 138, 1] },
    { boarder: [0, 0, 0, 1], fill: [252, 141, 89, 1] },
    { boarder: [0, 0, 0, 1], fill: [227, 74, 51, 1] },
    { boarder: [0, 0, 0, 1], fill: [179, 0, 0, 1] }
    ];